import * as THREE from "three";
import { prefilterEnvironment, withoutXrRendering } from "../../../util/prefilterEnvironment";

// Borrow the runtime's cube texture without taking ownership. Reproject into a
// small world-aligned cube so PMREM and r146 materials see the correct orientation.
export class RoomReflections {
  constructor(renderer, session) {
    this.renderer = renderer;
    this.binding = new window.XRWebGLBinding(session, renderer.getContext());
    this.borrowed = new THREE.CubeTexture();
    this.borrowed.isRenderTargetTexture = true;
    this.cube = new THREE.WebGLCubeRenderTarget(128, { type: THREE.HalfFloatType });
    this.camera = new THREE.CubeCamera(0.1, 10, this.cube);
    this.scene = new THREE.Scene();
    this.material = new THREE.ShaderMaterial({
      name: "RoomReflectionOrientation", side: THREE.BackSide, depthTest: false, depthWrite: false,
      uniforms: { room: { value: this.borrowed }, worldToProbe: { value: new THREE.Matrix3() } },
      vertexShader: `varying vec3 ray; void main() { ray = position; gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0); }`,
      fragmentShader: `uniform samplerCube room; uniform mat3 worldToProbe; varying vec3 ray;
        void main() { gl_FragColor = vec4(textureCube(room, worldToProbe * normalize(ray)).rgb, 1.0); }`,
    });
    this.geometry = new THREE.BoxGeometry(2, 2, 2);
    this.scene.add(new THREE.Mesh(this.geometry, this.material));
    this.filtered = null;
  }
  update(probe, orientation) {
    const nativeTexture = this.binding.getReflectionCubeMap(probe);
    if (!nativeTexture) return null;
    const properties = this.renderer.properties.get(this.borrowed);
    properties.__webglTexture = nativeTexture;
    this.material.uniforms.worldToProbe.value.setFromMatrix4(new THREE.Matrix4().makeRotationFromQuaternion(orientation)).transpose();
    let next;
    withoutXrRendering(this.renderer, () => {
      this.camera.update(this.renderer, this.scene);
      next = prefilterEnvironment(this.renderer, this.cube.texture);
    });
    const previous = this.filtered;
    this.filtered = next;
    previous?.dispose();
    return next.texture;
  }
  dispose() {
    // No Texture.dispose() on borrowed: its WebGLTexture belongs to WebXR.
    this.renderer.properties.remove(this.borrowed);
    this.filtered?.dispose(); this.cube.dispose();
    this.geometry.dispose(); this.material.dispose();
  }
}
